import React from 'react'
import moment from 'moment'

import { calendarTitleDateFormat as titleDateFormat } from '../../../configuration/configs'
import PrevArrow from '../../../assets/icons/calendar-prev.svg'
import NextArrow from '../../../assets/icons/calendar-next.svg'

const CalendarHeader = ({ currentDate, handleNextMonth, handlePrevMonth }) => (
  <div className="u-calendar__header">
    <div className="month-nav previous">
      <button className="btn__month-nav" onClick={handlePrevMonth}>
        <img src={PrevArrow} alt="Calendar Previous Month" />
      </button>
    </div>
    <div className="month-title">
      <h4 className="title">{moment(currentDate).format(titleDateFormat)}</h4>
    </div>
    <div className="month-nav next">
      <button className="btn__month-nav" onClick={handleNextMonth}>
        <img src={NextArrow} alt="Calendar Next Month" />
      </button>
    </div>
  </div>
)

export default CalendarHeader
